<div class="modal fade" role="dialog" id="myModal">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <ng-content select="[modal-header]"></ng-content>
        </h5>
        <button type="button" class="close" (click)="modalClose()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <ng-content select="[modal-body]"></ng-content>
      </div>
    </div>
  </div>
</div>